import { render, staticRenderFns } from "./ThemeForm.vue?vue&type=template&id=fb6ed166&scoped=true&"
import script from "./ThemeForm.vue?vue&type=script&lang=js&"
export * from "./ThemeForm.vue?vue&type=script&lang=js&"
import style0 from "./ThemeForm.vue?vue&type=style&index=0&id=fb6ed166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6ed166",
  null
  
)

export default component.exports